module.exports = __webpack_public_path__ + "img/stories-mockup-1.3fd184da.png";